(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hsa-b2b-product-guide"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => {
    document.querySelectorAll('[data-hsa-b2b-guide]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const openShopifyInbox = (attempt = 0) => {
        const chat = document.querySelector('shopify-chat');
        const activator = chat?.shadowRoot?.querySelector('[part="activator"]');

        if (activator) {
          activator.click();
          return;
        }

        if (attempt < 20) {
          window.setTimeout(() => openShopifyInbox(attempt + 1), 100);
        }
      };

      root.querySelectorAll('[data-shopify-inbox-open]').forEach((button) => {
        button.addEventListener('click', () => openShopifyInbox());
      });

      const links = Array.from(root.querySelectorAll('[data-guide-nav] a'));
      const sections = links.map((link) => document.querySelector(link.getAttribute('href'))).filter(Boolean);

      links.forEach((link) => {
        link.addEventListener('click', (event) => {
          const target = document.querySelector(link.getAttribute('href'));
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', link.getAttribute('href'));
        });
      });

      if (!('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver((entries) => {
        const activeEntry = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (!activeEntry) return;
        links.forEach((link) => link.removeAttribute('aria-current'));
        const activeLink = links.find((link) => link.getAttribute('href') === '#' + activeEntry.target.id);
        if (activeLink) activeLink.setAttribute('aria-current', 'true');
      }, { rootMargin: '-18% 0px -65% 0px', threshold: [0.01, 0.2, 0.5] });

      sections.forEach((guideSection) => observer.observe(guideSection));
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hsa-channel-letter-guide"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => {
    document.querySelectorAll('[data-hsa-channel-guide]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const openShopifyInbox = (attempt = 0) => {
        const host =
          document.getElementById('ShopifyChat') ||
          document.querySelector('inbox-online-store-chat');

        const toggle =
          host?.shadowRoot?.querySelector('button.chat-toggle') ||
          host?.shadowRoot?.querySelector('.chat-app > button');

        if (toggle) {
          toggle.click();
          return;
        }

        if (attempt < 12) {
          window.setTimeout(() => openShopifyInbox(attempt + 1), 250);
        }
      };

      root.querySelectorAll('[data-shopify-inbox-open]').forEach((button) => {
        button.addEventListener('click', () => openShopifyInbox());
      });

      const links = Array.from(root.querySelectorAll('[data-guide-nav] a'));
      const sections = links
        .map((link) => document.querySelector(link.getAttribute('href')))
        .filter(Boolean);

      links.forEach((link) => {
        link.addEventListener('click', (event) => {
          const target = document.querySelector(link.getAttribute('href'));
          if (!target) return;

          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', link.getAttribute('href'));
        });
      });

      if (!('IntersectionObserver' in window)) return;

      const observer = new IntersectionObserver(
        (entries) => {
          const activeEntry = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

          if (!activeEntry) return;

          links.forEach((link) => link.removeAttribute('aria-current'));
          const activeLink = links.find((link) => link.getAttribute('href') === '#' + activeEntry.target.id);
          if (activeLink) activeLink.setAttribute('aria-current', 'true');
        },
        { rootMargin: '-18% 0px -65% 0px', threshold: [0.01, 0.2, 0.5] }
      );

      sections.forEach((section) => observer.observe(section));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
